import defineCustomElement from '../define-custom-element.js';
import TpPagination from './tp-pagination.js';

defineCustomElement('tp-pagination', TpPagination);

export {
  TpPagination
}
